import { useEffect, useRef } from 'react';

// Source: https://usehooks.com/usePrevious/
const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  // Return previous value (happens before update in useEffect above)
  return ref.current;
};

export default usePrevious;
